<template>
  <div class="rtb-log-detail-adjustment__panel">
    <div
      class="rtb-log-detail-adjustment__panel-heading"
      @click="showAdjustment = !showAdjustment"
    >
      <i
        aria-hidden="true"
        class="fa fa-angle-right"
        :class="{'fa-rotate-90': showAdjustment}"
      />
      <i
        class="fa p-r-5 p-l-5"
        :class="adjustment.IsMatch ? 'fa-check green' : 'fa-close red'"
        :title="$t(adjustment.IsMatch ? 'MATCHED' : 'NOT_MATCHED')"
      />
      <span class="m-r-10">{{ adjustment.Setting.Criteria.TagId }} <strong>{{ adjustment.Setting.Criteria.ComparisonType }}</strong> {{ adjustment.Setting.Criteria.Value }}</span>
    </div>
    <collapse v-model="showAdjustment">
      <div class="rtb-log-detail-adjustment__panel-body">
        <table class="table_basic">
          <tbody>
            <tr v-if="adjustment.BidBefore">
              <th v-t="'CELL_BID_BEFORE'" scope="row" />
              <td>{{ adjustment.BidBefore }}</td>
            </tr>
            <tr>
              <th v-t="'CELL_ADJUSTMENT_TYPE'" scope="row" />
              <td>{{ adjustment.Setting.AdjustmentType }}</td>
            </tr>
            <tr>
              <th v-t="'CELL_ADJUSTMENT_VALUE'" scope="row" />
              <td>{{ adjustment.Setting.AdjustmentValue }}</td>
            </tr>
            <tr v-if="adjustment.BidAfter">
              <th v-t="'CELL_BID_AFTER'" scope="row" />
              <td>{{ adjustment.BidAfter }}</td>
            </tr>
            <tr>
              <th v-t="'CELL_MATCHED'" scope="row" />
              <td>{{ $t(adjustment.IsMatch ? 'YES': 'NO') }}</td>
            </tr>
            <tr>
              <th v-t="'CELL_REJECTED'" scope="row" />
              <td>{{ $t(adjustment.Rejected ? 'YES': 'NO') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </collapse>
  </div>
</template>
<script>
import messages from '../../../locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'RtbAdjustment',
  components: {
  },
  props: {
    adjustment: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      showAdjustment: false,
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>